/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 21/12/2021
 */


import GenogramItem from "@shared/Genogram/GenogramItem";
import {plainToClass} from "@qwoach/class-transformer-wrapper";
import TagsContainer from "@shared/Tags/TagsContainer";
import TimelineItem from "@shared/Timeline/TimelineItem";
import IFSPartsItem from "@shared/Genogram/IFSPartsItem.js";

let dummyFirebase = {
	auth(){
		return null
	},
	firestore(){
		return null
	}
}

export default class LocalDataManager {//extends QwoachDataManager {

	genogramItem: GenogramItem = null
	tagsContainer: TagsContainer = new TagsContainer()
	timelineItem: TimelineItem = null


	constructor() {
		// super(dummyFirebase);
	}

	async getGenogramByClientId(clientId){
		if(!this.genogramItem){
			let genogramItemPlain = {"jsonData":{"boxSelectionEnabled":true,"elements":{"nodes":[{"data":{"id":"1640029491056","type":"rectangle","name":"Alex","resize":true,"bg":"#1890FF","width":76,"height":76,"tags":[],"label":"Alex,\nClient, 40","isClient":true,"_name":"Alex","relationship":"Client","dateOfBirth":363995999999},"position":{"x":122.5,"y":87.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":"eh-preview-active"},{"data":{"id":"1640029493162","type":"ellipse","name":"Mary","resize":true,"bg":"#FFC069","width":76,"height":76,"tags":[],"label":"Mary,\nWife, 39","relationship":"Wife","dateOfBirth":391989599999},"position":{"x":402.5,"y":87.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":"eh-preview-active"},{"data":{"id":"1645258845305","type":"ellipse","name":"Alice","resize":true,"bg":"#FFC069","width":76,"height":76,"tags":[{"id":"67QSTBdJBMRlW2CHNrcY","createdAt":1645259092032,"schemaVersion":1,"isDeleted":false,"ownerIds":[],"_isSchemaMigrated":false,"_schemaMigratedFrom":-1,"_schemaMigratedTo":-1,"title":"Example Health Condition","color":"#8E24AA","description":"","usageCounter":1}],"label":"Alice,\nDaughter, 20","relationship":"Daughter","dateOfBirth":992555999999},"position":{"x":192.5,"y":332.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":"eh-preview-active"},{"data":{"isAuxNode":true,"parentEdgeId":"1640029494650","xPositionPercent":0.5053571428571428,"type":"round-rectangle","name":"","resize":true,"width":10,"height":10,"id":"aux_1645258846828","skipSnapToGridY":true,"tags":[]},"position":{"x":192.5,"y":225.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":""}],"edges":[{"data":{"source":"1640029491056","target":"1640029493162","id":"1645258866330","lineType":"bezier","title":"Very Close","lineSubType":"harmony3"},"position":{"x":17.5,"y":17.5},"group":"edges","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":true,"classes":""},{"data":{"source":"1640029491056","target":"1640029493162","id":"1640029494650","lineType":"segments","title":"Marriage","lineSubType":"family-marriage","auxNodes":["aux_1645258846828"]},"position":{"x":17.5,"y":17.5},"group":"edges","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":true,"classes":"eh-preview-active"},{"data":{"source":"1645258845305","target":"aux_1645258846828","id":"1645258846828","lineType":"bezier","title":"Straight Line","lineSubType":"straight"},"position":{"x":17.5,"y":17.5},"group":"edges","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":true,"classes":""}]},"pan":{"x":0,"y":0},"panningEnabled":true,"userPanningEnabled":true,"userZoomingEnabled":true,"zoom":1,"zoomingEnabled":true},"clientId":"pULtZcAzJGeImaInEPfR"}
			this.genogramItem = plainToClass(GenogramItem, genogramItemPlain)
			this.genogramItem.clientId = clientId
		}
		return this.genogramItem
	}

	async setGenogramItem(genogramItem){
		this.genogramItem = genogramItem
		console.log("LocalDataManager.setGenogramItem: genogramItem = ", genogramItem)
		console.log("LocalDataManager.setGenogramItem: genogramItem JSON = ", JSON.stringify(genogramItem))
		return this.genogramItem
	}


	async getIFSPartsItemByClientId(clientId) {
		if(!this.ifsPartsItem){
			// let genogramItemPlain = {"jsonData":{"boxSelectionEnabled":false,"elements":{"nodes":[{"data":{"id":"1712231247759", "nonDeletable": true, "type":"ellipse","name":"Core Self","label":"Core Self","resize":true,"bg":"#FFC069","width":176,"height":176},"position":{"x":332.5,"y":332.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":""}]},"pan":{"x":93,"y":-96},"panningEnabled":true,"userPanningEnabled":true,"userZoomingEnabled":true,"zoom":1,"zoomingEnabled":true}}
			// this.ifsPartsItem = plainToClass(IFSPartsItem, genogramItemPlain)
			this.ifsPartsItem = new IFSPartsItem()
			this.ifsPartsItem.setDefault()
			this.ifsPartsItem.clientId = clientId
		}
		return this.ifsPartsItem
	}

	async setIFSPartsItem(genogramItem){
		this.ifsPartsItem = genogramItem
		return this.ifsPartsItem
	}



	async getTagsContainerItem(){
		return this.tagsContainer
	}

	async setTagsContainer(tagsContainer){
		this.tagsContainer = tagsContainer
	}

	async getTimelineItemByClientId(clientId){
		if(!this.timelineItem){
			this.timelineItem = new TimelineItem(clientId)
		}
		return this.timelineItem
	}
	async setTimelineItem(timelineItem){
		this.timelineItem = timelineItem
		return this.timelineItem
	}

	async setClientProfile(clientProfile){
		return clientProfile
	}

}
